<template>
	<section v-show='getOccurrences'>
		<div class="container-fluid">
			<div class="row mt-2 mb-2">
				<div class="col-md-12">
					<h3 class="text-center">Ocorrências</h3>
				</div>
			</div>
		</div>
		<div class='barra-superior direita' >
			<div class='rede-social esquerda hover-change-color-pointer tamanho-aviso text-center' :class="{active: getAllOccurrence}" @click='historicolOccurrence' >
				<p class='p-1'>Ocorrências</p>
			</div>
			<div class='rede-social esquerda hover-change-color-pointer tamanho-aviso text-center' :class="{active: getNewOccurrence}" @click='newOccurrence' >
				<p class='p-1'>Nova Ocorrência</p>
			</div>
		</div>
		<div class="body">
			<todas-ocorrencias></todas-ocorrencias>
			<nova-ocorrencia></nova-ocorrencia>
		</div>
	</section>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex';

	export default {
		name: 'ocorrencias',
		computed:{
			...mapGetters(['getOccurrences','getAllOccurrence','getOccurrencesByDateAndStatus','getCnpj', 'getNewOccurrence']),
		},
		methods: {
			...mapActions(['setAllOccurrences','setNewOccurrences', 'fetchOcurrencesByDateAndStatus']),
			historicolOccurrence() {
				if (!this.getAllOccurrence){
					this.setNewOccurrences()
					this.setAllOccurrences()
				}
			},
			newOccurrence(){
				if (!this.getNewOccurrence) {
					this.setNewOccurrences()
					this.setAllOccurrences()
				}
			},
		},
	}
</script>

<style scoped>

</style>
